var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 6,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2117 24C11.4744 24 10.9203 23.806 10.5493 23.4179C10.1831 23.0299 10 22.4453 10 21.6642V10.3433C10 9.56716 10.1831 8.98259 10.5493 8.58955C10.9203 8.19652 11.4744 8 12.2117 8H15.4863V13.4776C15.4863 14.4179 15.9358 14.8881 16.8347 14.8881H22V21.6642C22 22.4403 21.8145 23.0224 21.4435 23.4104C21.0773 23.8035 20.5256 24 19.7883 24H12.2117ZM16.8561 13.8657C16.5945 13.8657 16.4637 13.7313 16.4637 13.4627V8.08209C16.6112 8.10697 16.761 8.17413 16.9132 8.28358C17.0654 8.38806 17.2247 8.52985 17.3912 8.70896L21.3222 12.8955C21.4935 13.0796 21.629 13.2488 21.7289 13.403C21.8288 13.5572 21.8906 13.7114 21.9144 13.8657H16.8561Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreement);
export default __webpack_public_path__ + "static/media/agreement.3e107ae84b0f953c5a46fa16807c635c.svg";
export { ForwardRef as ReactComponent };